export default __webpack_public_path__ + "static/media/importCSVDispatches.bb9a06a7.jpg";